import { render, staticRenderFns } from "./ComparatorDropdown.vue?vue&type=template&id=66d9e047&"
import script from "./ComparatorDropdown.vue?vue&type=script&lang=js&"
export * from "./ComparatorDropdown.vue?vue&type=script&lang=js&"
import style0 from "./ComparatorDropdown.vue?vue&type=style&index=0&id=66d9e047&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports